function isValidPostalCode(country, postalCode) {
  switch (country) {
    case "fr":
      // French postal codes are 5 digits long and start with a digit from 0 to 9
      return /^\d{5}$/.test(postalCode);

    case "be":
      // Belgian postal codes are 4 digits long and start with a digit from 1000 to 1999
      return /^[1-9]\d{3}$/.test(postalCode);

    case "lu":
      // Luxembourgish postal codes are 4 digits long and start with a digit from L-N
      return /^[L-N]\d{3}$/.test(postalCode);

    case "nl":
      // Dutch postal codes are 4 digits long and start with a digit from 1000 to 9999
      return /^[1-9]\d{3}$/.test(postalCode);

    case "de":
      // German postal codes are 5 digits long and start with a digit from 10000 to 99999
      return /^[1-9]\d{4}$/.test(postalCode);

    default:
      return false;
  }
}

function extendPostalCode(validator) {
  validator.extend(
    "postalcode",
    {
      validate: (value, { acceptedCountries }) => {
        console.log(acceptedCountries);
        if (!acceptedCountries || acceptedCountries.length == 0) {
          return true;
        }
        for (let i = 0; i < acceptedCountries.length; i++) {
          const country = acceptedCountries[i];
          if (!["be", "fr", "lu", "nl", "de"].includes(country)) {
            return true;
          }
          if (isValidPostalCode(country, value)) {
            return true;
          }
        }
        return false;
      },
    },
    ["acceptedCountries"],
  );
}

export default extendPostalCode;
